// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"29":"EntryInfo","594":"about"}[chunkId] + "." + {"29":"137e346c","594":"e4177451"}[chunkId] + ".js";
};